import React, {useEffect, useRef, useState} from 'react';
import styles from './index.module.less';
import {Button, Card, Classes, Elevation, FormGroup, InputGroup, Intent} from "@blueprintjs/core";
import classes from 'classnames';
import axios from 'axios';
import constant from "../../store/constant";
import {useDispatch} from "react-redux";
import { useHistory } from 'react-router-dom';
const Login = () => {
  const [userName, setUserName] = useState('');
  const [password, setPassword] = useState('');
  const [errorText, setErrorText] = useState('');
  const [loading, setLoading] = useState(false);
  const [qrCode, setQrCode] = useState(null);
  const [loginMessage, setLoginMessage] = useState(null);
  const pullToken = useRef('');
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    axios.post('/api/pytip/wechat_pub_login', {
      url: window.location.href
    }).then((response) => {
      const { code, data } = response.data;
      if (code === 0) {
        setQrCode(data.qr_code_url);
        pullToken.current = data.token;
        checkIsWxFollowed();
      }
    });
  }, []);

  const checkIsWxFollowed = () => {
    axios.get('/api/pytip/wechat_pub_login_check', {
      params: {
        token: pullToken.current
      }
    }).then((response) => {
      const { code, data } = response.data;
      if (code === 0) {
        if (data.status === 0) {
          setTimeout(checkIsWxFollowed, 1000);
          return;
        }
        handleWeChatRegister(data.token);
      } else {
        setLoginMessage('网络错误，请刷新页面');
      }
    })
  };

  const handleWeChatRegister = (token) => {
    axios.post('/api/pytip/wechat_pub_register', { token }).then((response) => {
      const { code } = response.data;
      if (code === 0) {
        if (code === 0) {
          setLoginMessage('微信登录成功，请稍后...');
          handleGetUserProfile();
        }
      }
    })
  };

  const handleGetUserProfile = () => {
    axios.get('/api/pytip/user/profile').then(response => {
      setLoading(false);
      const { code, data } = response.data;
      const { user_info: userInfo = {} } = data;
      if (code !== 0 || userInfo.user_id === null) {
        setErrorText('用户信息获取失败');
        return;
      }
      dispatch({
        type: constant.userInfo.SET_USER_INFO,
        payload: {
          avatar: userInfo.avatar,
          userId: userInfo.user_id,
          userName: userInfo.user_name,
          isWxBind: true
        }
      });
      history.replace('/')
    });
  };
  const handleRedirectToAccountLogin = () => {
    history.push('/account-login');
  };
  return (
    <div className={styles.login}>
      <Card className={styles.main} elevation={Elevation.FOUR}>
        <h4 className={classes(Classes.HEADING, styles.header)}>微信扫一扫关注公众号注册或登录</h4>
        <div className={styles.body}>
          <img src={qrCode} alt=""/>
        </div>
        <div className={styles.footer}>
          <Button type='button' large onClick={handleRedirectToAccountLogin}>用账号登录</Button>
        </div>
      </Card>
    </div>
  );
};

export default Login;
